import { useEffect, useRef, useState } from 'react'
import { View } from 'react-native'
import QrScanner from 'qr-scanner'

import { Stack } from '@/components/layout'

import { CameraUnavailable, ScanHeader, ScannerMask, useScanHandler } from './Scan2PayScreen.shared'

export default function Scan2PayScreen() {
  const scanner = useRef<QrScanner | null>(null)
  const videoEl = useRef<HTMLVideoElement>(null)
  const [cameraReady, setCameraReady] = useState<boolean>()
  const handleScanCode = useScanHandler(() => scanner.current?.destroy())
  const handleScanCodeRef = useRef(handleScanCode)
  handleScanCodeRef.current = handleScanCode

  useEffect(() => {
    if (!videoEl.current || scanner.current) return
    let mounted = true
    const activeScanner = new QrScanner(videoEl.current, ({ data }) => data && handleScanCodeRef.current(data), {
      onDecodeError: () => {},
      preferredCamera: 'environment',
      highlightScanRegion: false,
      highlightCodeOutline: false,
      maxScansPerSecond: 1
    })
    scanner.current = activeScanner
    activeScanner
      .start()
      .then(() => mounted && setCameraReady(true))
      .catch(() => mounted && setCameraReady(false))
    return () => {
      mounted = false
      activeScanner.destroy()
      if (scanner.current === activeScanner) scanner.current = null
    }
  }, [])

  if (cameraReady === false)
    return (
      <Screen>
        <CameraUnavailable />
      </Screen>
    )
  return (
    <Screen>
      <View className={'flex-1'}>
        <video ref={videoEl} className={'absolute inset-0 size-full object-cover'} />
        <ScannerMask ready={cameraReady === true} />
        <ScanHeader />
      </View>
    </Screen>
  )
}

function Screen({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Stack.Screen options={{ headerShown: false }} />
      {children}
    </>
  )
}
